// extracted by mini-css-extract-plugin
export default {"container":"HeadingTop_container__veDyS","heading":"HeadingTop_heading__njKkS","subheading":"HeadingTop_subheading__avE6i","hr":"HeadingTop_hr__g+1JT"};